import dayjs, { Dayjs } from 'dayjs'
import { DocType, EventDoc } from 'types/api/changes'
import { isConvertedGroupId } from 'utils/groups'
import { eventDisplayDate, eventEndTimestamp } from 'utils/eventDates'
import { getDefaultTimezone } from 'utils/timezone'

export function isSomeDayInstance(event: EventDoc) {
  if (!event) return false

  return (
    event.StartDate === 'null' ||
    event.StartDate === '' ||
    event.someday === '1'
  )
}

export function isLateInstance(event: EventDoc, ignoreRecurrence?: boolean) {
  if (!event || !event.StartDate || event.someday === '1') return false

  if (event.Type === DocType.EVENT) return false

  if (
    ignoreRecurrence &&
    event.Recurrence &&
    typeof event.Recurrence !== 'string'
  ) {
    return false
  }

  const today = dayjs().tz(getDefaultTimezone()).format('YYYY-MM-DD')
  return (
    event.EndDate !== undefined &&
    eventDisplayDate(event, event.EndDate).format('YYYY-MM-DD') < today
  )
}

export function isEventRecurring(event: EventDoc) {
  return (
    event.Recurrence != null &&
    event.Recurrence != undefined &&
    typeof event.Recurrence !== 'string'
  )
}

export function isEventRecurrenceInstanceValid(
  event: EventDoc,
  visibleAreaStart: dayjs.Dayjs
) {
  const isEventRecurrenceValid =
    event.Recurrence != null &&
    event.Recurrence != undefined &&
    typeof event.Recurrence !== 'string' &&
    (!event.Recurrence.EndDate ||
      Number(event.Recurrence.EndDate) >= visibleAreaStart.unix())

  return isEventRecurrenceValid
}

export function isEventInstanceWithinTimePeriod(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
): boolean {
  if (!visibleAreaStart.isValid() || !visibleAreaEnd.isValid()) return false
  const zone = getDefaultTimezone()
  const firstDate = visibleAreaStart.tz(zone).format('YYYY-MM-DD')
  const lastDate = visibleAreaEnd.tz(zone).format('YYYY-MM-DD')
  const startDate = eventDisplayDate(event, event.StartDate, zone)
  let endDate = eventDisplayDate(event, eventEndTimestamp(event), zone)
  if (!startDate.isValid() || !endDate.isValid()) return false
  if (
    event.AllDay === '1' &&
    isConvertedGroupId(event.GroupID) &&
    endDate.isAfter(startDate)
  )
    endDate = endDate.subtract(1, 'day')
  const start = startDate.format('YYYY-MM-DD')
  const end = endDate.format('YYYY-MM-DD')
  const today = dayjs().tz(zone).format('YYYY-MM-DD')
  if (event.lateOriginalStartTime && firstDate <= today && lastDate >= today)
    return true
  return start <= lastDate && end >= firstDate
}

export function eventLengthInDays(event: EventDoc) {
  if (!event.StartDate || !event.EndDate) return 0

  const startDate = dayjs.utc(
    eventDisplayDate(event, event.StartDate).format('YYYY-MM-DD')
  )
  const endDate = dayjs.utc(
    eventDisplayDate(event, eventEndTimestamp(event)).format('YYYY-MM-DD')
  )
  return endDate.diff(startDate, 'day')
}
